import React from "react";
import { STRIPE_PK } from "../../../../../constants";

class StripeCheckoutHandler extends React.Component {
  componentDidMount() {
    this.handler = StripeCheckout.configure({
      key: STRIPE_PK,
      image: "https://assets.topnine.co/landing/square-logo.png",
      locale: "auto",
      token: this.props.onTokenSuccess,
    });
  }
  openStripe = () => {
    this.handler.open({
      name: this.props.name || "Top Nine",
      description: this.props.description || "Instagram Top Nine",
      amount: parseInt(this.props.amount || 199),
    });
    window.addEventListener("popstate", function() {
      this.handler.close();
    });
  };
  render() {
    return this.props.children({ openStripe: this.openStripe, ...this.props });
  }
}

export default StripeCheckoutHandler;
